export default {
  title: "FAQ Categories",
  subtitle: "Manage FAQ categories",

  addNew: "Add New FAQ Category",
  createFaqCategory: "Create FAQ Category",
  editFaqCategory: "Edit FAQ Category",
  deleteFaqCategory: "Delete FAQ Category",

  actions: {
    back: "Back",
    update: "Update",
    updating: "Updating..."
  },

  fields: {
    name: "Name",
    description: "Description",
    displayOrder: "Display Order",
    isActive: "Active"
  },

  placeholders: {
    name: "Enter name in Arabic and English",
    description: "Enter description in Arabic and English"
  },

  messages: {
    createSuccess: "FAQ category created successfully",
    createError: "Failed to create FAQ category",
    updateSuccess: "FAQ category updated successfully",
    updateError: "Failed to update FAQ category",
    deleteSuccess: "FAQ category deleted successfully",
    deleteError: "Failed to delete FAQ category",
    deleteConfirm: "Are you sure you want to delete this FAQ category?",
    noFaqCategories: "No FAQ categories found",
    fetchError: "Failed to fetch FAQ categories"
  },

  validation: {
    nameRequired: "Name is required",
    fillAllFields: "Please fill all required fields"
  },

  table: {
    displayOrder: "Order",
    name: "Name",
    description: "Description",
    status: "Status",
    actions: "Actions"
  },

  status: {
    active: "Active",
    inactive: "Inactive"
  },

  breadcrumbs: {
    faqCategories: "FAQ Categories",
    create: "Create FAQ Category",
    edit: "Edit FAQ Category"
  }
};
